<template>
  <div
    id="form-step-container"
    class="pb-6 overflow-y-auto"
    style="
      height: calc(-65px + 100vh);
      background: #f7f6fa;
      scroll-behavior: smooth;
    "
  >
    <!-- Loader -->
    <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading || loading">
      <gd-loader :label="$t('frontend_loading')"/>
    </div>
    
    <div class="relative w-full flex flex-col justify-start">
      <div class="min-h-full h-auto pb-6">
        <div class="w-1/2 flex m-auto" v-if="allStepsConfigured">
          <div
            class="flex flex-row w-full justify-center"
            style="color: #989ab2; border-bottom: 1px solid #dcdcea"
          >
            <gd-tabs
              class="forms-configure-step-tabs"
              :tabs="tabs"
              :current-tab="currentTab"
              :wrapper-class="'pt-10 gs-default-tabs'"
              :tab-class="mainTabClass"
              :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
              :line-class="'gs-default-tabs-active-line'"
              @onClick="handleConfiguredWizardTabChange"
            />
          </div>
        </div>

        <div class="relative w-full flex flex-col" v-if="!allStepsConfigured">
          <div class="flex flex-row w-full px-4 justify-center wizard-tabs">
            <gd-tabs
              :tabs="tabs"
              :current-tab="currentTab"
              :disableNotCompleted="true"
              :wrapper-class="'pt-12 px-0 gs-default-tabs'"
              :tab-class="mainTabClass"
              :tab-active-class="'gs-default-tabs-item-active'"
              :line-class="'gs-default-tabs-active-line'"
              @onClick="handleTabChange"
              :key="
                $t('frontend_groovemail_contact_tabs_forms_formfields')
              "
            />
          </div>
        </div>

        <div class="relative w-full h-full flex flex-col justify-start px-4">
          <div class="rounded w-full">
            <div
              v-if="currentTab === 'step1'"
            >
              <step1
                ref="step1"
                substep="build"
                :model="model"
                @updateModel="model = $event"
                @saveFormWithUpdatedFields="saveFormWithUpdatedFields"
                @on-validate="stepValidationSuccessful('step1', $event)"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              ></step1>
            </div>
            <div
              v-if="currentTab === 'step1.2'"
            >
              <step1
                ref="step1.2"
                :model="model"
                substep="design"
                @updateModel="model = $event"
                @saveFormWithUpdatedFields="saveFormWithUpdatedFields"
                @on-validate="stepValidationSuccessful('step1', $event)"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              ></step1>
            </div>
            <div v-if="currentTab === 'step2'">
              <step2
                ref="step2"
                :model="model"
                @updateModel="model = $event"
                @stepValidity="stepValidity"
                @saveOnEmailContentReset="saveMailform()"
                @on-validate="stepValidationSuccessful('step2', $event)"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              ></step2>
            </div>
            <div v-if="currentTab === 'step5'">
              <step5
                ref="step5"
                :model="model"
                @updateModel="model = $event"
                @stepValidity="stepValidity"
                @saveOnEmailContentReset="saveMailform()"
                @on-validate="stepValidationSuccessful('step5', $event)"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              ></step5>
            </div>
            <div v-if="currentTab === 'step6'">
              <step6
                ref="step6"
                :model="model"
                @updateModel="model = $event"
                @on-validate="stepValidationSuccessful('step6', $event)"
                @showLoader="showLoader"
                @hideLoader="hideLoader"
              ></step6>
            </div>
          </div>
        </div>
        <div
          class="flex justify-center"
        >
          <gd-button
            variant="outline"
            size="auto"
            v-if="currentTab != 'step1'"
            class="mr-3"
            @click="moveBackOnWizard"
          >
            {{ $t('frontend_groovemail_forms_create_back') }}
          </gd-button>
          <gd-button
            v-if="currentTab != 'step6'"
            variant="primary"
            size="auto"
            @click="moveNextOnWizard"
          >
            {{ $t('frontend_next') }}
          </gd-button>
          <gd-button
            variant="primary"
            size="auto"
            v-if="currentTab === 'step6'"
            @click="moveBackToFormListingWithSave"
            >{{ $t('frontend_finish') }}</gd-button
          >
        </div>
      </div>
    </div>
    <portal to="headerContent">
      <div class="flex flex-row">
        <gd-button
          variant="outline"
          size="auto"
          v-if="currentTab != 'step1'"
          @click="moveBackOnWizard"
        >
          {{ $t('frontend_groovemail_forms_create_back') }}
        </gd-button>
        <gd-button
          variant="primary"
          size="auto"
          class="ml-3"
          @click="saveMailform"
        >
          {{ $t('frontend_save') }}
        </gd-button>
        <gd-button
          v-if="currentTab != 'step6'"
          variant="primary"
          size="auto"
          class="ml-3"
          @click="moveNextOnWizard"
        >
          {{ $t('frontend_products_create_save_next') }}
        </gd-button>
        <gd-button
          variant="outline"
          size="auto"
          class="ml-3"
          v-if="currentTab !== 'step6'"
          @click="saveAndExitWizard"
        >
          {{ $t('frontend_exit') }}
        </gd-button>
        <gd-button
          variant="outline"
          size="auto"
          class="ml-3"
          v-if="currentTab === 'step6'"
          @click="moveBackToFormListingWithSave"
          >{{ $t('frontend_finish') }}</gd-button
        >
      </div>
    </portal>
    <portal to="headerBreadCrumb">
      <div
        class="flex h-full items-center cursor-pointer text-grey-500 hover:text-primary"
        @click="moveBackToFormListing"
      >
        <ExitIcon class="w-5 h-5"/>
      </div>
    </portal>

    <confirm-modal
      :ref="`confirmation-leving-form`"
      :name="`confirmation-leving-form`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_campaigns_forms_exit_without_saving')"
      @confirm="confirmLeaveForm"
    />

    <!-- confirm style save global or local or exit -->
    <gd-modal
      id="confirm-save-style-type"
      name="confirm-save-style-type"
      :title="$t('frontend_save_form_style_title')"
    >
      <div class="p-6 border-t border-grey-300">
        <p class="text-sm text-copy pb-0 mb-8">
          {{ 
            this.activePreset?.form_id ? $t('frontend_chnage_alert_desc') : $t('frontend_save_form_style_desc')
          }}
        </p>
        <div class="flex justify-center">
          <gd-button
            size="auto"
            @click="cancelAndCloseAlert()"
          > {{ $t('frontend_dont_save') }} </gd-button>

          <gd-button
            variant="primary"
            size="auto"
            class="ml-3"
            v-if="!this.activePreset?.form_id"
            @click="confirmSaveFormStyle('global')"
          > {{ $t('frontend_save_form_style_global') }} </gd-button>

          <gd-button
            variant="primary"
            size="auto"
            class="ml-3"
            @click="confirmSaveFormStyle('local')"
          > {{ $t('frontend_save_form_style_local') }} </gd-button>
        </div>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { required, url } from 'vuelidate/lib/validators';
import themeConfig from '@/theme/themeConfig.js';
import Mailform from '@/models/Mailform';
import step1 from './step1';
import step2 from './step2main';
import step5 from './step5';
import step6 from './step6';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import ExitIcon from '@/assets/images/icons/new/exit_arrow_new.svg';

export default {
  name: 'CreateForm',
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',

  components: {
    step1,
    step2,
    step5,
    step6,
    ExitIcon,
  },

  validations: {
    model: {
      confirmlink_pageurl: {
        url,
        // required,
      },
      success_pageurl: {
        url,
        required,
      },
    },
  },

  data() {
    return {
      allStepsConfigured: false,
      lastConfiguredStep: '',
      postValidationTab: 'step2',
      currentTab: '',
      loaderColor: themeConfig.appPrimaryColor,
      fullPageLoader: true,
      isLoading: false,

      exitButtonClicked: false,
      model: {
        name: '',
        form_fields: [],
        integrations: {},
        default_preset: '',
        form_heading: this.$t('frontend_groovemail_forms_form_creation_form_heading_default'),
        form_sub_heading: this.$t('frontend_groovemail_forms_form_creation_form_sub_heading_default'),
        form_submit_button_text: 'Submit',
        optin: 'single',
        confirmlink_sendoption: 'email',
        confirmlink_gateway: '',
        confirmlink_sender_id: null,
        confirmlink_subject: '',
        confirmlink_previewtext: '',
        confirmlink_content: `${this.$t('frontend_forms_confirmation_default_content')}: {optin_confirmation_link}`,
        confirm_email_sections: '',
        confirm_editor_type: 1,
        confirm_email_id: null,
        confirm_template_name: '',
        confirm_template_folder: null,
        confirmlink_sms_content: `${this.$t('frontend_forms_confirmation_default_content')}: {optin_confirmation_link}`,
        confirmlink_page: 'custom',
        confirmlink_destination: '',
        confirmlink_hypertext: '',
        confirmlink_pageurl: '',
        success_destination: 'ExternalUrl',
        success_hypertext: '',
        success_option: 'url',
        success_pageurl: this.$store.getters.appUrl,
        welcome_msg_option: 'notsend',
        welcome_msg_gateway: '',
        welcome_sender_id: null,
        welcome_msg_sendername: '',
        welcome_msg_senderemail: '',
        welcome_msg_replyemail: '',
        welcome_msg_content: '',
        welcome_email_sections: '',
        welcome_editor_type: 3,
        welcome_email_id: null,
        welcome_template_name: '',
        welcome_template_folder: null,
        welcome_msg_sms_content: '',
        welcome_msg_subject: '',
        welcome_msg_previewtext: '',
        form_design: 'other',
        formid: '',
        assigntags: [],
        assignlists: [],
        assignsequences: [],
        recipients: [],
        default_acc_email: true,
      },
    };
  },

  computed: {
    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.supBrand.title;
    },
    
    // Get the active preset from store
    activePreset() {
      return this.$store.getters['forms/activePreset'];
    },
    // Get the form style changed flag from store
    isStyleChanged() {
      return this.$store.getters['forms/isStyleChanged'];
    },

    ...mapState({
      loading: state => state.forms.loading,
      activePresetId: state => state.forms.activePresetId,
    }),
    
    tabs() {
      return [
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
          ${this.$t(
            'frontend_groovemail_contact_tabs_forms_formfields'
          )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step1',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
          Design <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step1.2',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
          ${this.$t(
            'frontend_groovemail_contact_tabs_forms_optin_settings'
          )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step2',
        },
        {
          title: `<span class="text-sm  font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
          ${this.$t('Integrations')} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step5',
        },
        {
          title: `<span class="text-sm  font-semibold last-child"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_contact_tabs_forms_finish'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step6',
        },
      ];
    },

    mainTabClass() {
      if (this.currentTab === 'step1') {
        return 'pb-4 gs-default-tabs-item';
      }
      return 'pb-4 gs-default-tabs-item';
    },
  },

  async created() {
    try {
      // show loader
      this.showLoader();
      
      if (this.$route.params.id === undefined) {
        this.mailform = new Mailform({});
      } else {
        this.mailform = await Mailform.$find(this.$route.params.id);
        this.model.name = this.mailform.name;
        this.model.default_preset = this.mailform.default_preset ?? '';
        this.model.form_fields = JSON.parse(this.mailform.form_fields);
        if(this.mailform.integrations){
          if(this.mailform.integrations === "[]"){
            this.mailform.integrations = "{}";
          }
          this.model.integrations = JSON.parse(this.mailform.integrations);
        }
        this.model.recipients = (this.mailform.recipients && this.mailform.recipients.length) ? JSON.parse(this.mailform.recipients): [];
        this.model.default_acc_email = this.mailform.default_acc_email;
        this.model.optin = this.mailform.optin;
        this.model.formid = this.$route.params.id;
        if (this.mailform.hasOwnProperty('form_heading')) {
          this.model.form_heading = this.mailform.form_heading
            ? this.mailform.form_heading
            : '';
        }
        if (this.mailform.hasOwnProperty('form_sub_heading')) {
          this.model.form_sub_heading = this.mailform.form_sub_heading
            ? this.mailform.form_sub_heading
            : '';
        }
        this.model.form_submit_button_text = this.mailform.form_submit_button_text
          ? this.mailform.form_submit_button_text
          : this.model.form_submit_button_text;
        this.model.confirmlink_sendoption = this.mailform.confirmlink_sendoption;
        this.model.confirmlink_gateway = this.mailform.confirmlink_gateway;
        this.model.confirmlink_sender_id = this.mailform.confirmlink_sender_id;
        this.model.confirmlink_subject = this.mailform.confirmlink_subject;
        this.model.confirmlink_previewtext = this.mailform.confirmlink_previewtext;
        if (this.mailform.confirmlink_sendoption === 'email') {
          this.model.confirm_editor_type = this.mailform.confirm_editor_type ? +this.mailform.confirm_editor_type : 1;
          if (this.mailform.confirm_email_id) {
            this.model.confirm_editor_type = 3;
            this.model.confirm_email_id = this.mailform.confirm_email_id;
            await this.fetchTemplateData(this.model.confirm_email_id, 1);
          } else {
            this.model.confirmlink_content = this.mailform.confirmlink_content;
            const confirmEmailSections = this.mailform.confirm_email_sections
              ? JSON.parse(this.mailform.confirm_email_sections)
              : '';
            this.model.confirm_email_sections = confirmEmailSections || '';
          }
        } else if (this.mailform.confirmlink_sendoption === 'sms') {
          this.model.confirmlink_sms_content = this.mailform.confirmlink_content;
        }
        this.model.confirmlink_page = this.mailform.confirmlink_page;
        this.model.confirmlink_destination = this.mailform.confirmlink_destination;
        this.model.confirmlink_hypertext = this.mailform.confirmlink_hypertext;
        this.model.confirmlink_pageurl = this.mailform.confirmlink_pageurl;
        this.model.success_hypertext = this.mailform.success_hypertext;
        this.model.success_destination = this.mailform.success_destination;
        this.model.success_option = this.mailform.success_option
          ? this.mailform.success_option
          : 'url';
        this.model.success_pageurl = this.mailform.success_pageurl
          ? this.mailform.success_pageurl
          : this.$store.getters.appUrl;
        this.model.welcome_msg_option = this.mailform.welcome_msg_option;
        this.model.welcome_msg_gateway = this.mailform.welcome_msg_gateway;
        this.model.welcome_sender_id = this.mailform.welcome_sender_id;
        this.model.welcome_msg_subject = this.mailform.welcome_msg_subject;
        this.model.welcome_msg_previewtext = this.mailform.welcome_msg_previewtext;
        if (this.mailform.welcome_msg_option === 'email') {
          this.model.welcome_editor_type = this.mailform.welcome_editor_type ? +this.mailform.welcome_editor_type : 3;
          if (this.mailform.welcome_email_id) {
            this.model.welcome_editor_type = 3;
            this.model.welcome_email_id = this.mailform.welcome_email_id;
            await this.fetchTemplateData(this.model.welcome_email_id, 2);
          } else {
            this.model.welcome_msg_content = this.mailform.welcome_msg_content;
            const welcomeEmailSections = this.mailform.welcome_email_sections
              ? JSON.parse(this.mailform.welcome_email_sections)
              : '';
            this.model.welcome_email_sections = welcomeEmailSections || '';
          }
        } else if (this.mailform.welcome_msg_option === 'sms') {
          this.model.welcome_msg_sms_content = this.mailform.welcome_msg_content;
        }
        this.model.assigntags = JSON.parse(this.mailform.tags);
        this.model.assignlists = JSON.parse(this.mailform.lists);
        this.model.assignsequences = JSON.parse(this.mailform.sequences);
        this.model.form_design = this.mailform.form_design;
        this.getLastConfiguredStep();
      }
      // hide loader
      this.hideLoader();

    } catch (error) {
      // show error alert
      this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
    }
  },

  mounted() {
    this.model.confirmlink_gateway = `${this.supBrandName} server`;
  },

  beforeRouteLeave(to, from, next) {
    // check if the user is leaving the page
    if(this.currentTab === 'step1.2' && this.isStyleChanged && !this.exitButtonClicked) {

      // stop the page exit
      next(false);

      // show the confirmation modal
      this.openLeaveFormConfirm();
    } else {
      // Allow the navigation
      next();

      // Reset the exitButtonClicked flag
      this.exitButtonClicked = false;
    }
  },

  methods: {
    async fetchTemplateData(id, type) {
      this.showLoader();
      try {
        const templateData = await axios.get(`email/template/${id}`);
        this.hideLoader();
        this.assignTemplateDataInBuilder(templateData, type);
      } catch (err) {
        this.hideLoader();
      }
    },

    assignTemplateDataInBuilder(templateData, type) {
      if (
        templateData &&
        templateData.data
      ) {
        if (type === 1) {
          this.model.confirm_template_name = templateData.data.name;
          this.model.confirm_template_folder = templateData.data.category_id;
          this.model.confirmlink_content
            = templateData.data.message ? templateData.data.message : '';
          const confirmEmailSections = templateData.data.emailContentSections
            ? JSON.parse(templateData.data.emailContentSections)
            : '';
          this.model.confirm_email_sections = confirmEmailSections || '';
        } else if (type === 2) {
          this.model.welcome_template_name = templateData.data.name;
          this.model.welcome_template_folder = templateData.data.category_id;
          this.model.welcome_msg_content
            = templateData.data.message ? templateData.data.message : '';
          const welcomeEmailSections = templateData.data.emailContentSections
            ? JSON.parse(templateData.data.emailContentSections)
            : '';
          this.model.welcome_email_sections = welcomeEmailSections || '';
        }
      }
    },

    stepValidity(valid, step) {
      if (this.allStepsConfigured) {
        if (valid) {
          this.lastConfiguredStep = '';
        } else {
          this.lastConfiguredStep = step;
        }
      }
    },

    async handleConfiguredWizardTabChange(newTab) {
      // show loader
      this.showLoader();
      
      try {
        if (this.lastConfiguredStep) {
          const refToValidate = this.$refs[this.lastConfiguredStep];
          if (refToValidate.validateForSaveAndExit()) {
            this.currentTab = newTab;
          }
        } else {
          await this.saveMailform();
          this.currentTab = newTab;
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },


    // Checks whether the email confirmation link is valid.
    validatEmaileUrl() {
      // Returns true if the link is valid, false otherwise.
      return (
        this.model.confirmlink_subject &&
        !this.$v.model.confirmlink_pageurl.$invalid &&
        !this.$v.model.success_pageurl.$invalid &&
        this.model.confirmlink_content &&
        this.model.confirmlink_content.includes('{optin_confirmation_link}') &&
        this.model.confirmlink_sender_id &&
        this.model.confirmlink_sender_id !== '-1'
      );
    },

    // Checks whether the email confirmation subject and content are valid.
    validateSubjictAndContent() {
      // Returns true if the subject and content are valid, false otherwise.
      return (
        this.model.confirmlink_subject &&
        !this.$v.model.confirmlink_pageurl.$invalid &&
        this.model.confirmlink_content &&
        this.model.confirmlink_content.includes('{optin_confirmation_link}') &&
        this.model.confirmlink_sender_id &&
        this.model.confirmlink_sender_id !== '-1'
      );
    },

    // Checks whether the SMS confirmation link is valid.
    validateSmsUrl() {
      // Returns true if the link is valid, false otherwise.
      return (
        !this.$v.model.success_pageurl.$invalid &&
        !this.$v.model.confirmlink_pageurl.$invalid &&
        this.model.confirmlink_sms_content &&
        this.model.confirmlink_sms_content.includes('{optin_confirmation_link}') &&
        this.model.confirmlink_sender_id &&
        this.model.confirmlink_sender_id !== '-1'
      );
    },

    // Checks whether the SMS confirmation content is valid.
    validateSmsContent() {
      // Returns true if the content is valid, false otherwise.
      return (
        !this.$v.model.confirmlink_pageurl.$invalid &&
        this.model.confirmlink_sms_content &&
        this.model.confirmlink_sms_content.includes('{optin_confirmation_link}') &&
        this.model.confirmlink_sender_id &&
        this.model.confirmlink_sender_id !== '-1'
      );
    },

    // Checks whether the form data in step 2 is valid.
    getStep2Valid() {
      let isValid = false;

      if (this.model.optin === 'double') {
        if (this.model.confirmlink_sendoption === 'email') {
          // Sets isValid to true if the email confirmation link or subject and content are valid.
          isValid = this.model.success_option === 'url' ? this.validatEmaileUrl() : this.validateSubjictAndContent();
        } else {
          // Sets isValid to true if the SMS confirmation link or content are valid.
          isValid = this.model.success_option === 'url' ? this.validateSmsUrl() : this.validateSmsContent();
        }
      } else {
        // Sets isValid to true if the success page URL is not invalid.
        isValid = this.model.success_option === 'url' ? !this.$v.model.success_pageurl.$invalid : true;
      }

      // Checks whether the sender information for the welcome message is valid.
      const senderValidation = () => {
        // Returns true if the sender information is valid, false otherwise.
        if (this.model.welcome_msg_option === 'email') {
          return ( 
            this.model.welcome_msg_subject &&
            this.model.welcome_sender_id &&
            this.model.welcome_sender_id !== '-1' &&
            this.model.welcome_msg_content
          );
        } else if (this.model.welcome_msg_option === 'sms') {
          return (
            this.model.welcome_sender_id &&
            this.model.welcome_sender_id !== '-1' &&
            this.model.welcome_msg_sms_content
          );
        } else {
          return true;
        }
      };

      // Sets isValid to true if the form data is valid and all required fields are filled out.
      if (isValid && senderValidation() && this.model.assignlists && this.model.assignlists.length) {
        isValid = true;
      } else {
        isValid = false;
      }

      return isValid;
    },

    getLastConfiguredStep() {
      if (this.$route.name === 'EditForm') {
        if (this.getStep2Valid()) {
          this.currentTab = 'step1';
          this.allStepsConfigured = true;

          if (this.$route.query?.step === 'design') {
            this.currentTab = 'step1.2';
            return;
          }
          if (this.$route.query?.step === 'integrations') {
            this.currentTab = 'step5';
            return;
          }
        } else if (!this.getStep2Valid()) {
          this.currentTab = 'step2';
        } else {
          this.currentTab = 'step1';
        }
      } else {
        this.currentTab = 'step1';
      }
    },

    handleTabChange(newTab) {
      if (this.currentTab > newTab) {
        // ahow loader
        this.showLoader();

       this.currentTab = newTab;
        document.getElementById('form-step-container').scrollTop = 0;

        // hide loader
        this.hideLoader();
      }
    },

    async moveNextOnWizard() {
      // show loader
      this.showLoader();


      const currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.currentTab);
      const nextTab = this.tabs[currentlySelectedTabIndex + 1].value;

      // get the reference of the current tab
      const refToValidate = this.$refs[this.currentTab];
      
      // function to execute after the validation
      const moveToNextPage = () => {
        // move to the next tab
        this.currentTab = nextTab;
        this.postValidationTab = nextTab;
        document.getElementById('form-step-container').scrollTop = 0;
      };


      // check if the current tab is step1.2 and the style has been changed
      if(this.currentTab === 'step1.2' && this.isStyleChanged){
        // hide loader
        this.hideLoader();

        if(this.activePreset.form_id){
          // save the form style locally
          await this.$store.dispatch('forms/createLocalPreset', {...this.activePreset, formId: this.mailform.id});

          // move to the next tab
          moveToNextPage();

          return;
        }

        // opne save style modal
        this.openConfirmStyleChangeModal();

        // Listen for the 'modal-closed' event
        this.$root.$once('modal-close', () => {
          // call the execute function
          moveToNextPage();
        });

        // stop the execution
        return;
      }
      
      try {
        // validate the current tab
        const isValid = await refToValidate.validate();

        if (isValid) {
          // save the form style before moving to next tab
          this.saveMailform();
          
          // call the execute function
          moveToNextPage();
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    // open confirmation save style type modal
    openConfirmStyleChangeModal() {
      this.$root.$emit('modal-open', 'confirm-save-style-type') ;
    },

    // close confirmation save style type modal
    closeConfirmStyleChangeModal() {
      this.$root.$emit('modal-close', 'confirm-save-style-type') ;
    },

    moveBackOnWizard() {
      const currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.currentTab);
      const nextTab = this.tabs[currentlySelectedTabIndex - 1].value;
      this.postValidationTab = nextTab;

      // function to execute after the validation
      const moveToNextPage = () => {
        // move to the next tab
        this.currentTab = nextTab;
        document.getElementById('form-step-container').scrollTop = 0;
      };

      // save the form style before moving back
      if(this.currentTab === 'step1.2' && this.isStyleChanged){
        // open the confirmation modal
        this.openConfirmStyleChangeModal();

        // Listen for the 'modal-closed' event
        this.$root.$once('modal-close', () => {
          // call the execute function
          moveToNextPage();
        });

        // stop the execution
        return;
      }

      // call the execute function
      moveToNextPage();
    },

    async saveFormWithUpdatedFields() {
      if (this.model.formid !== '') {
        this.saveMailform();
      } else {
        await this.createMailForm();
      }
    },

    async stepValidationSuccessful(name, isValid) {
      if (isValid) {
        if (this.model.formid !== '') {
          this.saveMailform();
        } else {
          await this.createMailForm();
        }
        this.currentTab = this.postValidationTab;
        document.getElementById('form-step-container').scrollTop = 0;
      }
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    async createMailForm() {
      // show loader
      this.showLoader();

      this.mailform = new Mailform({});

      this.mailform.name = this.model.name;
      this.mailform.form_fields = JSON.stringify(this.model.form_fields);
      this.mailform.integrations = JSON.stringify(this.model.integrations);
      this.mailform.default_preset = this.model.default_preset ?? '';
      this.mailform.recipients = JSON.stringify(this.model.recipients);
      this.mailform.default_acc_email = this.model.default_acc_email;
      this.mailform.optin = this.model.optin;
      this.mailform.form_heading = this.model.form_heading;
      this.mailform.form_sub_heading = this.model.form_sub_heading;
      this.mailform.form_submit_button_text = this.model.form_submit_button_text;
      this.mailform.confirmlink_sendoption = this.model.confirmlink_sendoption;
      this.mailform.confirmlink_gateway = this.model.confirmlink_gateway;
      this.mailform.confirmlink_sender_id = this.model.confirmlink_sender_id;
      this.mailform.confirmlink_subject = this.model.confirmlink_subject;
      this.mailform.confirmlink_previewtext = this.model.confirmlink_previewtext;
      this.mailform.confirm_editor_type = this.model.confirm_editor_type;
      this.mailform.confirmlink_content =
        this.model.confirmlink_sendoption === 'email'
          ? this.model.confirmlink_content
          : this.model.confirmlink_sendoption === 'sms'
          ? this.model.confirmlink_sms_content
          : '';
      this.mailform.confirmlink_page = this.model.confirmlink_page;
      this.mailform.confirmlink_destination = this.model.confirmlink_destination;
      this.mailform.confirmlink_hypertext = this.model.confirmlink_hypertext;
      this.mailform.confirmlink_pageurl = this.model.confirmlink_pageurl;
      this.mailform.success_destination = this.model.success_destination;
      this.mailform.success_hypertext = this.model.success_hypertext;
      this.mailform.success_option = this.model.success_option;
      this.mailform.success_pageurl = this.model.success_pageurl;
      this.mailform.welcome_msg_option = this.model.welcome_msg_option;
      this.mailform.welcome_msg_gateway = this.model.welcome_msg_gateway;
      this.mailform.welcome_sender_id = this.model.welcome_sender_id;
      this.mailform.welcome_msg_subject = this.model.welcome_msg_subject;
      this.mailform.welcome_msg_previewtext = this.model.welcome_msg_previewtext;
      this.mailform.welcome_editor_type = this.model.welcome_editor_type;
      this.mailform.welcome_msg_content =
        this.model.welcome_msg_option === 'email'
          ? this.model.welcome_msg_content
          : this.model.welcome_msg_option === 'sms'
          ? this.model.welcome_msg_sms_content
          : '';
      this.mailform.tags = JSON.stringify(this.model.assigntags);
      this.mailform.lists = JSON.stringify(this.model.assignlists);
      this.mailform.sequences = JSON.stringify(this.model.assignsequences);
      this.mailform.form_design = this.model.form_design
        ? this.model.form_design
        : 'other';

      // save the form data in the database
      try {
        const response = await this.mailform.save();
        this.model.formid = response.id;

      } catch(error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
        
      // hide the loader
      this.hideLoader();
    },

    /* close the alert and reset the styles */
    async cancelAndCloseAlert() {
      // show the loader
      this.showLoader();
      
      // get the styles from the api and reset the styles to the old styles
      await axios.get(`${window.config.apiUrl}/mailformstyle/${this.activePresetId}`)
        .then((response) => {
          // reset the styles
          this.activePreset.styles = response.data.styles;
          
          // hide the loader
          this.hideLoader();
        })
        .catch((error) => {
          this.requestErrorAlert(error.response?.data?.error);
        });

      // close the form style builder
      this.$store.dispatch('forms/setFormStyleBuilder', false);
      
      // set style changed to false
      this.$store.dispatch('forms/setIsStyleChanged', false);

      // close the alert modal
      this.closeConfirmStyleChangeModal();
    },

    // save the form
    async saveMailform() {
      // check if the current tab is step 1.2
      if(this.currentTab === 'step1.2' && this.isStyleChanged){
        if(this.activePreset.form_id){
          // save the form style locally
          await this.$store.dispatch('forms/createLocalPreset', {...this.activePreset, formId: this.mailform.id});
        } else {
          // opne save style modal
          this.openConfirmStyleChangeModal();
        }
      } else {
        // save the form data
        await this.saveFormData();
      }
    },

    // save the form data
    async saveFormData() {
      // show loader
      this.showLoader();

      // close the form style builder
      this.$store.dispatch('forms/setFormStyleBuilder', false);

      // prepare the form data for saving
      const mailformData = {
        name: this.model.name,
        form_fields: JSON.stringify(this.model.form_fields),
        integrations: JSON.stringify(this.model.integrations),
        default_preset: this.model.default_preset ?? '',
        optin: this.model.optin,
        recipients: JSON.stringify(this.model.recipients),
        default_acc_email: this.model.default_acc_email,
        form_heading: this.model.form_heading,
        form_sub_heading: this.model.form_sub_heading,
        form_submit_button_text: this.model.form_submit_button_text,
        confirmlink_sendoption: this.model.confirmlink_sendoption,
        confirmlink_gateway: this.model.confirmlink_gateway,
        confirmlink_sender_id: this.model.confirmlink_sender_id,
        confirmlink_subject: this.model.confirmlink_subject,
        confirmlink_previewtext: this.model.confirmlink_previewtext,
        confirm_editor_type: this.model.confirm_editor_type,
        confirmlink_content:
          this.model.confirmlink_sendoption === 'email'
            ? this.model.confirmlink_content
            : this.model.confirmlink_sendoption === 'sms'
            ? this.model.confirmlink_sms_content
            : '',

        confirm_email_id: this.model.confirm_email_id || null,
        confirm_template_name: this.model.confirm_template_name || '',
        template_subcategory_id_optin: this.model.confirm_template_folder || null,
        confirmlink_page: this.model.confirmlink_page,
        confirmlink_destination: this.model.confirmlink_destination,
        confirmlink_hypertext: this.model.confirmlink_hypertext,
        confirmlink_pageurl: this.model.confirmlink_pageurl,
        success_destination: this.model.success_destination,
        success_hypertext: this.model.success_hypertext,
        success_option: this.model.success_option,
        success_pageurl: this.model.success_pageurl,
        welcome_msg_option: this.model.welcome_msg_option,
        welcome_msg_gateway: this.model.welcome_msg_gateway,
        welcome_sender_id: this.model.welcome_sender_id,
        welcome_msg_subject: this.model.welcome_msg_subject,
        welcome_msg_previewtext: this.model.welcome_msg_previewtext,
        welcome_editor_type: this.model.welcome_editor_type,
        welcome_msg_content:
          this.model.welcome_msg_option === 'email'
            ? this.model.welcome_msg_content
            : this.model.welcome_msg_option === 'sms'
            ? this.model.welcome_msg_sms_content
            : '',
        welcome_email_id: this.model.welcome_email_id || null,
        welcome_template_name: this.model.welcome_template_name || '',
        template_subcategory_id_welcome: this.model.welcome_template_folder || null,
        tags: JSON.stringify(this.model.assigntags),
        lists: JSON.stringify(this.model.assignlists),
        sequences: JSON.stringify(this.model.assignsequences),
      };
      
      // save the form data in the database
      try {
        const response =  await this.mailform.updateMailForm(this.mailform.id, mailformData);
        
        if (response && response.confirm_email_id) {
          this.model.confirm_email_id = response.confirm_email_id;
        }
        if (response && response.welcome_email_id) {
          this.model.welcome_email_id = response.welcome_email_id;
        }

        // hide the loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    /* confirm save the styles */
    async confirmSaveFormStyle(type){
      if(type === 'global'){
        // save the form style globally
        await this.$store.dispatch('forms/updatePreset', this.activePreset);
      } else {
        // save the form style locally
        await this.$store.dispatch('forms/createLocalPreset', {...this.activePreset, formId: this.mailform.id});
      }
      
      // close the modal
      this.closeConfirmStyleChangeModal();

      // save the form data
      await this.saveFormData();
      
      // set style changed to false
      this.$store.dispatch('forms/setIsStyleChanged', false);
    },

    moveBackToFormListingWithSave() {
      this.saveMailform();
      this.$router.push({ name: 'Forms' });
    },

    // open archive form modal
    openLeaveFormConfirm() {
      // open the modal
      this.$refs[`confirmation-leving-form`].open();
    },

    // leave the form without saving
    async confirmLeaveForm() {
      // Indicate that the exit button has been clicked
      this.exitButtonClicked = true;

      // move to the forms listing page
      this.$router.push({ name: 'Forms' });
    },


    async moveBackToFormListing() {

      // save the form style before moving back
      if(this.currentTab === 'step1.2' && this.isStyleChanged){
        // show alret modal to save the form style or not before leaving the page
        this.openConfirmStyleChangeModal();
        
        // Listen for the 'modal-closed' event
        this.$root.$once('modal-close', async () => {
          // set the exit button clicked flag to true
          this.exitButtonClicked = true;
          // execute the function          
          this.$router.push({ name: 'Forms' });
        });

        // stop the execution
        return;
      }

      // check if the current tab is not step 6
      const changeMadeInCurrentStep = this.$refs[this.currentTab].checkChangesMadeOnThisStep();
      

      if (changeMadeInCurrentStep && this.currentTab !== 'step6') {
        // open confirmation leave form modal
        this.openLeaveFormConfirm();

      } else {
        // move to the forms listing page
        this.$router.push({ name: 'Forms' });
      }
    },

    /* save and exit the wizard */
    async saveAndExitWizard() {
      const currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.currentTab);
      const nextTab = this.tabs[currentlySelectedTabIndex + 1].value;
      this.postValidationTab = nextTab;
      const refToValidate = this.$refs[this.currentTab];
      const isStepValid = refToValidate.validateForSaveAndExit();

      // function to execute after the validation
      const executeFun = async () => {
        if (this.model.formid !== '') {
          // save the form style
          this.saveMailform();
        } else {
          // create the form
          await this.createMailForm();
        }
        // move to the forms listing page
        this.$router.push({ name: 'Forms' });
      };


      // check if the step is valid
      if (isStepValid) {
        // save the form style before moving back
        if(this.currentTab === 'step1.2' && this.isStyleChanged){
          // open the confirmation modal
          this.openConfirmStyleChangeModal();
          
          // Listen for the 'modal-closed' event
          this.$root.$once('modal-close', async () => {
            // set the exit button clicked flag to true
            this.exitButtonClicked = true;
            // execute the function
            executeFun();
          });

          // stop the execution
          return;
        }

        // execute the function
        executeFun();
      }
    },
  },
};
</script>
